module.exports = __webpack_public_path__ + "img/video.95ec9121.svg";